import styles from './styles.module.scss';

const CareRemoval = () => {
    return (
        <div className={styles.careRemovalContainer}>
            <h1>Tattoo Care & Removal</h1>
        </div>
    );
}

export default CareRemoval;
